
// Main App Component with proper routing
import { useState, useEffect } from 'react';
import { AdminDashboard } from './adminDashboard.jsx';
// import { ScribeDashboard } from './ScribeDashboard.jsx';
import { FeedbackAuditDashboard } from './FeedbackAuditDashboard.jsx';

export default function AdminApp() {
  const [currentScreen, setCurrentScreen] = useState('admin-dashboard');
  // const [userRole, setUserRole] = useState('admin');
  // const [currentScribe, setCurrentScribe] = useState('Sarah Chen');

  // Handle screen navigation
  const handleViewFeedback = () => {
    setCurrentScreen('feedback-audit');
  };

  const handleViewSession = (sessionId) => {
    // Redirect to the Medical Scribe application with the session ID
    window.location.href = `/scribe?sessionId=${sessionId}`;
  };

  const handleStartEditing = (sessionId) => {
    // Redirect to chart editing screen in scribe app
    window.location.href = `/scribe/edit?sessionId=${sessionId}`;
  };

  const handleRequestExtension = (sessionId, days, reason) => {
    console.log('Request extension for session:', sessionId, days, reason);
    // Implement extension request logic here
  };

  // Check user role on mount
  // useEffect(() => {
  //   // In a real app, you would check the user's role from JWT or session
  //   const savedRole = localStorage.getItem('userRole') || 'admin';
  //   setUserRole(savedRole);
  //   setCurrentScreen(savedRole === 'scribe' ? 'scribe-dashboard' : 'admin-dashboard');
  // }, []);

  // const handleRoleChange = (role) => {
  //   setUserRole(role);
  //   localStorage.setItem('userRole', role);
  //   setCurrentScreen(role === 'scribe' ? 'scribe-dashboard' : 'admin-dashboard');
  // };

  return (
    <div className="min-h-screen w-full bg-gray-50">
      {/* Top Navigation */}
      {/* <div className="bg-white border-b-2 border-neutral-900 p-4">
        <div className="max-w-7xl mx-auto flex items-center justify-between">
          <h1 className="text-2xl">VirtualScribe Healthcare AI Scribe Platform</h1>
          <div className="flex gap-3">
            <button
              onClick={() => handleRoleChange('admin')}
              className={`px-4 py-2 border-2 border-neutral-900 ${
                userRole === 'admin' ? 'bg-neutral-900 text-white' : 'bg-white'
              }`}
            >
              Admin View
            </button>
            <button
              onClick={() => handleRoleChange('scribe')}
              className={`px-4 py-2 border-2 border-neutral-900 ${
                userRole === 'scribe' ? 'bg-neutral-900 text-white' : 'bg-white'
              }`}
            >
              Scribe View
            </button>
          </div>
        </div>
      </div> */}

      <div className="w-full px-4 sm:px-6 lg:px-8 py-4 sm:py-6">
        {currentScreen === 'admin-dashboard' && (
          <AdminDashboard
            onViewFeedback={handleViewFeedback}
            onViewSession={handleViewSession}
            onRequestExtension={handleRequestExtension}
          />
        )}

        {/* {currentScreen === 'scribe-dashboard' && (
          <ScribeDashboard
            scribeName={currentScribe}
            onStartEditing={handleStartEditing}
          />
        )} */}

        {currentScreen === 'feedback-audit' && (
          <FeedbackAuditDashboard
            onBack={() => setCurrentScreen('admin-dashboard')}
          />
        )}
      </div>
    </div>
  );
}
